import 'assets/scss/styles.scss'
import flowRight from 'lodash/flowRight'
import classNames from 'classnames'
import { makeSelectCurOrg } from 'logic/orgs'
import { cancelSweetAlert, okSweetAlert, makeSelectShowSweetAlert, makeSelectSweetAlertMsg, makeSelectSweetAlertProps } from 'logic/sweetalert'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import SweetAlert from 'react-bootstrap-sweetalert'
import ReactGA from 'react-ga'

class Layout extends Component {

  componentDidMount () {
    if (this.props.org && this.props.org.portal && this.props.org.portal.ga) {
      ReactGA.initialize(this.props.org.portal.ga)
    }
  }

  renderSetPrimaryColor = color => (
    <style>
      {`
      .tt-primary-color, .text-primary {color: ${color} !important; }
      .tt-primary-bg-color {background - color: ${color} !important; }
      .form-check input[type="checkbox"]:checked + .form-check-sign::after {background - color: ${color} !important; }
      .qty-form-control .qty-switches .qty-btn {border - color: ${color} !important; }
      .qty-form-control .qty-switches .qty-btn:hover {background - color: ${color} !important; }
      .tt-primary-border-color {border - color: ${color} !important; }
    `}
    </style>
  )

  renderAddCustomCss = css => (
    <style>
      {css}
    </style>
  )

  render () {
    const { org, showSweetAlert, sweetAlertProps, sweetAlertMsg } = this.props
    return (
      <div className={classNames('tt-wrap', { hzl: process.env.HZL_INST, tt: !process.env.HZL_INST })}>
        <SweetAlert
          confirmBtnBsStyle="primary"
          {...sweetAlertProps}
          show={showSweetAlert}
          title=""
          openAnim={false}
          onCancel={this.props.actions.cancelSweetAlert}
          onConfirm={this.props.actions.okSweetAlert}
        >
          {sweetAlertMsg}
        </SweetAlert>
        { (org && org.portal && org.portal.custom_css) ? this.renderAddCustomCss(org.portal.custom_css) : null }
        { (org && org.portal && org.portal.color) ? this.renderSetPrimaryColor(org.portal.color) : null }
        {this.props.children}
      </div>
    )
  }
}


const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  showSweetAlert: makeSelectShowSweetAlert(),
  sweetAlertProps: makeSelectSweetAlertProps(),
  sweetAlertMsg: makeSelectSweetAlertMsg(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    cancelSweetAlert,
    okSweetAlert
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(Layout);
